import Tr from 'translations/Translations';
import {createSelectItem} from "../components/Select";

export default [
    createSelectItem(true, Tr('yes')),
    createSelectItem(false, Tr('no'))
]

